import React from 'react';

type IconProps = {
  className?: string;
};

export function TileViewIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V24C36 28.4183 32.4183 32 28 32H8C3.58172 32 0 28.4183 0 24V8Z"
        fill="#C4D6D1"
      />
      <path
        d="M22.6667 10H13.3333C12.597 10 12 10.597 12 11.3333V20.6667C12 21.403 12.597 22 13.3333 22H22.6667C23.403 22 24 21.403 24 20.6667V11.3333C24 10.597 23.403 10 22.6667 10Z"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14H24"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18H24"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10V22"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 10V22"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ListViewIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V24C36 28.4183 32.4183 32 28 32H8C3.58172 32 0 28.4183 0 24V8Z"
        fill="#C4D6D1"
      />
      <path
        d="M12 11.333H12.0067"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16H12.0067"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20.667H12.0067"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.333 11.333H23.9997"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.333 16H23.9997"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.333 20.667H23.9997"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
